module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/logoIW_5A.587902c4.svg";